import { http } from "@/utils/request";
import type {
  ActivitiesResponse,
  GetActivitiesParams,
  Activity,
} from "@/types/activity";
// 新增：导入商品相关的类型
import type { CommoditiesResponse } from "@/types/commodities";

export const activityService = {
  // 获取活动列表
  getActivities: async (
    params: GetActivitiesParams
  ): Promise<ActivitiesResponse> => {
    return http.get<ActivitiesResponse>("/activity/list", params);
  },

  // 更新活动状态
  updateActivityStatus: async ({ id, ...params }: Activity): Promise<void> => {
    return http.put(`/activity/${id}`, params);
  },

  // 创建活动
  createActivity: async (params: Activity): Promise<void> => {
    return http.post(`/activity`, params);
  },

  // 新增：获取可供选择的商品列表
  // 这个方法封装了获取商品的逻辑，使得活动组件无需直接与商品服务交互
  getSelectableProducts: async (): Promise<CommoditiesResponse> => {
    // 调用商品列表接口，获取所有可用的商品（分页设置得很大以获取全部）
    return http.get<CommoditiesResponse>("/product/list", {
      page: 1,
      page_size: 99, // 获取足够多的商品作为选项
      status: "active", // 通常只关联“使用中”的商品
    });
  },
};
